export default __webpack_public_path__ + "static/media/OnePager.445e9d69.pdf";